import type { KnownDomainSlugs } from 'bundles/browse-common/types/domain';

const knownDomainSlugs = [
  'arts-and-humanities',
  'business',
  'computer-science',
  'data-science',
  'health',
  'information-technology',
  'language-learning',
  'math-and-logic',
  'personal-development',
  'physical-science-and-engineering',
  'social-sciences',
] satisfies KnownDomainSlugs[];

export function isKnownDomainSlug(slug?: string): slug is KnownDomainSlugs {
  return knownDomainSlugs.includes(slug ?? '');
}

const subdomainsThatAreSkills = [
  'algorithms',
  'business-strategy',
  'chemistry',
  'cloud-computing',
  'data-analysis',
  'data-management',
  'design-and-product',
  'economics',
  'electrical-engineering',
  'entrepreneurship',
  'finance',
  'health-informatics',
  'machine-learning',
  'marketing',
  'math-and-logic',
  'mechanical-engineering',
  'personal-development',
  'probability-and-statistics',
  'psychology',
  'public-health',
  'research',
  'software-development',
];

export function isSubdomainAndSkill(subdomain: string) {
  return subdomainsThatAreSkills.includes(subdomain);
}

export function toDomainUrl(slug: string) {
  return `/browse/${slug}`;
}
